export const fetchDownloadUrl = async ({accessToken, bucketKey, objectKey}) => {

    if (!accessToken || !objectKey || !objectKey) {
        throw new Error('Missing required parameters for fetching download url');    }

    // Prepare the request headers
    const requestHeaders = new Headers({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
    });

    // Prepare the request object
    const request = new Request(`https://developer.api.autodesk.com/oss/v2/buckets/${bucketKey}/objects/${objectKey}/signeds3download`, {
        method: 'GET',
        headers: requestHeaders
    });
    try {

        const response = await fetch(request);

        // Check if the response is okay
        if (!response.ok) {
            throw new Error(`HTTP error from fetching download url: ${response.status} ${response.statusText}`);
        }
        const assets = await response.json();
        console.log('Fetched download url:', assets);
        return assets;


    } catch (error) {
        // Log and rethrow any errors encountered
        console.error('Error fetching download url:', error);
        throw error;
    }
};


